import React from 'react';
import './CustomTree.scss';

const FolderIcon = () => (
    <span className="custom-tree__icon" role="img" aria-label="folder">📁</span>
);

const Spinner = () => (
    <span className="custom-tree__spinner" />
);

function CustomTree({
    data = [],
    onSelect,
    selectedId,
    onExpand,
    expandedIds = [],
    loadingIds = [],
    parentId = null
}) {
    const renderNode = (node) => {
        const isExpanded = expandedIds.includes(node.id);
        const isLoading = loadingIds.includes(node.id);
        const hasChildren = node.hasChildren || (node.children && node.children.length > 0);
        const isSelected = selectedId === node.id;

        return (
            <div className={`custom-tree__node${isSelected ? ' selected' : ''}`}
                key={node.id}
                data-id={node.id}
            >
                <div className="custom-tree__row">
                    {hasChildren ? (
                        <span
                            className="custom-tree__toggle"
                            onClick={() => onExpand(node)}
                        >
                            {isExpanded ? '−' : '+'}
                        </span>
                    ) : (
                        <span className="custom-tree__toggle-placeholder" />
                    )}
                    <span
                        className="custom-tree__label"
                        onClick={() => onSelect(node)}
                    >
                        <FolderIcon />
                        {node.name}
                        {isLoading && <Spinner />}
                    </span>
                </div>
                {isExpanded && node.children && node.children.length > 0 && (
                    <div className="custom-tree__children">
                        {node.children.map(child => renderNode(child))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="custom-tree">
            {data.map(node => renderNode(node))}
        </div>
    );
}

export default CustomTree; 